import { Redirect, Route } from 'react-router-dom';
import { isEmpty } from '../../helpers/isEmpty';
import { useSelector } from 'react-redux';
import React from 'react';
import config from "../../globals/config";
import {useFusionAuth} from "@fusionauth/react-sdk";


//If state.auth.loggedIn is true, we display the component

const PrivateRoute = ({ component: Component, ...rest }: any) => {
    const {isAuthenticated} = useFusionAuth()
    const router = useSelector((state: any) => state.router);

    return (
        <Route
            {...rest}
            render={props =>
                isAuthenticated ? (
                    <React.Fragment>
                        <Component {...props} />
                    </React.Fragment>
                ) : isAuthenticated ? (
                    <Redirect
                        to={{
                            pathname: '/loading',
                            state: {
                                from: router.location,
                            },
                        }}
                    />
                ) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {
                                from: props.location,
                            },
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
